import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaWindowClose } from "react-icons/fa";
import CommonModal from "Components/CommonModal";
import { outClick } from "JS/common";
import { FaPlus } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import ProductInputModal from "./ProductInputModal";
import ProductSearchModal from "./ProductSearchModal";

const AddApplicationTypeModal = ({
  id,
  setModal,
  editAddProduct,
  setEditAddProduct,
  isNew,
  addDetailItem,
}) => {
  const [alertMessage] = useState("");
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });
  const navigate = useNavigate();

  useEffect(() => {
    window.addEventListener("click", (e) => outClick(e, setModal));
  }, []);

  const [isDirectOpen, setIsDirectOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const [productItemList, setProductItemList] = useState([]);
  const [noneProduct, setNoneProduct] = useState([]);

  const [selectedItem, setSelectedItem] = useState(null);

  // 상품 추가시 분류 변경 불가능
  const [isClassLocked, setIsClassLocked] = useState(false);

  useEffect(() => {
    if (editAddProduct && editAddProduct !== true) {
      const {
        kind_code,
        apply_type,
        notice_register_product,
        none_register_product,
      } = editAddProduct;

      setSelectedItem({ kind_code });
      setIsClassLocked(true);

      // 출원 유형 선택
      setTimeout(() => {
        const applyTypeEl = document.getElementById("apply_type");
        if (applyTypeEl) applyTypeEl.value = apply_type;
      }, 0);

      // 상품 리스트 구성
      if (notice_register_product) {
        const noticeList = notice_register_product.map((p) => ({
          product: p,
          kind_code,
        }));
        setProductItemList(noticeList);
      }

      if (none_register_product) {
        const noneList = none_register_product.map((p) => ({
          product: p,
          kind_code,
        }));
        setNoneProduct(noneList);
      }
    }
  }, [editAddProduct]);

  const handleNewSubmit = () => {
    const applyType = document.getElementById("apply_type")?.value;
    if (!applyType) {
      alert("출원 유형을 선택해주세요.");
      return;
    }

    const hasProducts = productItemList.length > 0 || noneProduct.length > 0;
    if (!hasProducts) {
      alert("상품을 하나 이상 추가해주세요.");
      return;
    }

    const noticeProducts = productItemList
      .filter((item) => item.kind_code === selectedItem?.kind_code)
      .map((item) => item.product);

    const noneNoticeProducts = noneProduct
      .filter((item) => item.kind_code === selectedItem?.kind_code)
      .map((item) => item.product);

    const detailItem = {
      apply_type: applyType.toUpperCase(),
      mark_class: String(selectedItem?.kind_code),
      notice_register_product: noticeProducts,
      none_register_product: noneNoticeProducts,
    };

    addDetailItem(detailItem);

    setModal(false);
  };

  return (
    <>
      <div className="modal-background">
        <div className="personnel-modal-container product">
          <div className="personnel-modal-header">
            <h3 className="personnel-modal-title">
              상품 / 업종 및 출원 유형 수정
            </h3>
            <div
              className="personnel-modal-close"
              onClick={() => {
                setModal(false);
                setEditAddProduct(false);
              }}
            >
              <FaWindowClose />
            </div>
          </div>
          <div className="product-add-wrap">
            <div className="select-wrap">
              <div>
                <h4>상품 분류</h4>
                <select
                  name="mark_class"
                  id="mark_class"
                  onChange={(e) =>
                    setSelectedItem({ kind_code: e.target.value })
                  }
                  disabled={isClassLocked}
                >
                  <option value="">선택</option>
                  {Array.from({ length: 45 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}류
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <h4>출원 유형</h4>
                <select name="apply_type" id="apply_type">
                  <option value="">선택</option>
                  <option value="NORMAL">일반 출원</option>
                  <option value="SEARCH">조사출원</option>
                  <option value="FAST">신속출원</option>
                  <option value="FASTSEARCH">신속조사출원</option>
                </select>
              </div>
            </div>

            <div className="product-search-wrap">
              <button
                onClick={() => {
                  if (!selectedItem?.kind_code) {
                    alert("상품 분류를 먼저 선택해주세요.");
                    return;
                  }
                  setIsDirectOpen(true);
                }}
              >
                직접 입력하여 상품추가 <FaPlus />
              </button>
              <button
                onClick={() => {
                  if (!selectedItem?.kind_code) {
                    alert("상품 분류를 먼저 선택해주세요.");
                    return;
                  }
                  setIsSearchOpen(true);
                }}
              >
                키워드 검색하여 상품추가 <FaPlus />
              </button>
            </div>
            <section>
              <div className="title-wrap">
                <h4>
                  {selectedItem?.kind_code
                    ? `${selectedItem.kind_code}류`
                    : "분류를 선택해주세요."}
                </h4>
              </div>
              {productItemList.length > 0 && (
                <>
                  <h5>
                    고시 상품 (
                    {
                      productItemList.filter(
                        (item) => item.kind_code === selectedItem?.kind_code
                      ).length
                    }
                    )
                  </h5>
                  <article>
                    {productItemList
                      .filter(
                        (item) => item.kind_code === selectedItem?.kind_code
                      )
                      .map((item, idx) => (
                        <button key={`${item.product}-${idx}`}>
                          {item.product}
                          <IoMdClose
                            onClick={(e) => {
                              e.stopPropagation();
                              setProductItemList((prev) =>
                                prev.filter(
                                  (p) =>
                                    !(
                                      p.product === item.product &&
                                      p.kind_code === item.kind_code
                                    )
                                )
                              );
                            }}
                          />
                        </button>
                      ))}
                  </article>
                </>
              )}

              {noneProduct.length > 0 && productItemList.length > 0 && <hr />}
              {noneProduct.length > 0 && (
                <>
                  <h5>
                    비고시 상품 (
                    {
                      noneProduct.filter(
                        (item) => item.kind_code === selectedItem?.kind_code
                      ).length
                    }
                    )
                  </h5>
                  <article>
                    {noneProduct
                      .filter(
                        (item) => item.kind_code === selectedItem?.kind_code
                      )
                      .map((item, idx) => (
                        <button key={`${item.product}-${idx}`}>
                          {item.product}
                          <IoMdClose
                            onClick={(e) => {
                              e.stopPropagation();
                              setNoneProduct((prev) =>
                                prev.filter(
                                  (p) =>
                                    !(
                                      p.product === item.product &&
                                      p.kind_code === item.kind_code
                                    )
                                )
                              );
                            }}
                          />
                        </button>
                      ))}
                  </article>
                </>
              )}
            </section>
            {!isNew ? (
              <div className="button-wrap">
                <button onClick={handleNewSubmit}>
                  {editAddProduct ? "수정" : "추가"}
                </button>
                <button
                  onClick={() => {
                    setModal(false);
                    setEditAddProduct(false);
                  }}
                >
                  취소
                </button>
              </div>
            ) : (
              <div className="button-wrap">
                <button onClick={handleNewSubmit}>
                  {editAddProduct ? "수정" : "추가"}
                </button>
                <button
                  onClick={() => {
                    setModal(false);
                    setEditAddProduct(false);
                  }}
                >
                  취소
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alertMessage === "closeModal") setModal(false);
            if (alertMessage === "logout") navigate("/");
          }}
        />
      )}
      {isDirectOpen && (
        <ProductInputModal
          setIsDirectOpen={setIsDirectOpen}
          productItemList={productItemList}
          setProductItemList={setProductItemList}
          selectedItem={selectedItem}
          setNoneProduct={setNoneProduct}
          setIsClassLocked={setIsClassLocked}
          noneProduct={noneProduct}
        />
      )}
      {isSearchOpen && (
        <ProductSearchModal
          setIsSearchOpen={setIsSearchOpen}
          selectedItem={selectedItem}
          productItemList={productItemList}
          setProductItemList={setProductItemList}
          setIsClassLocked={setIsClassLocked}
        />
      )}
    </>
  );
};

export default AddApplicationTypeModal;
